import { useNavigate } from "react-router-dom"

export const MoreBtn = () => {
    const navigate = useNavigate()

    return (
        <>
            <div className="row">
                <div className="col-12">
                    <a href="javascript:void(0)" class="btn more_details_all mt-3" onClick={() => navigate('/AllOurTeam?ScreenName=AllOurTeam')}>Read More <i class="fa-solid fa-angles-right"></i></a>
                </div>
            </div>
        </>
    )
}
